
























































import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions } from '@/ts/store/Constants';
import BuildingList from '@/components/Admin/Lists/BuildingList.vue';
import AddButton from '@/components/Admin/Layout/AddButton.vue';
import AddDocumentButton from '@/components/Admin/Layout/AddDocumentButton.vue';
import AddEventButton from '@/components/Admin/Layout/AddEventButton.vue';
import AddNotificationButton from '@/components/Admin/Layout/AddNotificationButton.vue';
import SelectedItems from '@/components/Admin/Layout/SelectedItems.vue';
import EditBuildingForm from '@/components/Admin/Forms/EditBuildingForm.vue';
import BuildingData from '@/ts/BuildingData';
import AddDocumentForm from '@/components/Admin/Forms/AddDocumentForm.vue';
import EventFlyout from '@/components/Flyouts/EventFlyout.vue';
import BroadcastFlyout from '@/components/Flyouts/BroadcastFlyout.vue';
import Recipients from '@/components/Admin/Panels/Recipients.vue';

@Component({
    components: {
        AddButton,
        AddNotificationButton,
        AddDocumentButton,
        AddEventButton,
        BuildingList,
        EditBuildingForm,
        AddDocumentForm,
        SelectedItems,
        EventFlyout,
        BroadcastFlyout,
        Recipients,
    },
    computed: {
        ...mapGetters({
            formVisible: 'Viewport/isAddFormVisible',
            formVisibleTwo: 'Viewport/isEditFormVisible',
        }),
    },
})

export default class Buildings extends Vue {
    @Prop() public buildingData!: BuildingData;

    constructor() {
        super();
    }

    get recipientsVisible(): boolean {
        return this.$store.getters['Recipients/getRecipientsVisible'];
    }

    get getBuildingData(): any {
        return this.$store.getters['Buildings/allBuildings'];
    }

    get activeBuilding(): BuildingData {
        return this.$store.getters['Buildings/activeBuilding'];
    }

    get addMenuVisible() {
        return this.$store.getters['Viewport/menuVisible'];
    }

    get editMenuVisible() {
        return this.$store.getters['Buildings/editMenuVisible'];
    }

    get createBuildingFormVisible() {
        return this.$store.state.Buildings.createFormVisible;
    }

    get editBuildingFormVisible() {
        return this.$store.state.Buildings.editFormVisible;
    }

    get addMenuClass() {
        return {
            activeForm: this.addMenuVisible,
        };
    }

    get editMenuClass() {
        return {
            activeForm: this.editMenuVisible,
        };
    }

    get hasSelectedProjects(): any {
        return this.$store.getters['Projects/selectedProjects'].length;
    }

    get hasSelectedBuildings(): any {
        return this.$store.getters['Buildings/selectedBuildings'].length;
    }

    get hasSelectedProperties(): any {
        return this.$store.getters['Properties/selectedProperties'].length;
    }

    get hasSelectedItem(): boolean {
        return this.hasSelectedProjects ||  this.hasSelectedBuildings || this.hasSelectedProperties;
    }

    public diselectAllBuildings() {
        const buildingComponent = (this.$refs.buildings as any);
        const flexibleTable = buildingComponent.$refs.flexibleTable as any;
        const qgridTable = flexibleTable.$refs.qgrid as any;
        flexibleTable.removeSelections();
        qgridTable.selected_prop = [];
    }

    public addBuilding() {
        this.$store.dispatch(Actions.INITIATE_BUILDING);
        this.slideInForm('add-building');
    }

    public addNotification() {
        this.$store.dispatch(Actions.INITIATE_NOTIFICATION);
        this.slideInForm('add-notification');
    }

    public addEvent() {
        this.slideInForm('add-event');
    }

    public addDocument() {
        this.slideInForm('add-document');
    }

    public slideInForm(formKey: string) {
        this.$store.dispatch(Actions.SHOW_FORM, formKey);
    }

    public mounted() {
        this.$store.dispatch(Actions.FETCH_BUILDINGS);
    }
}
